import { BlockStatus } from '@next-space/fe-api-idl';
import { cache } from 'src/redux/store';

import { getDomain } from './url-utils';

export const isPublicPageDeleted = (uuid: string) => {
  const block = cache.blocks[uuid];
  return getDomain() && block?.status !== BlockStatus.NORMAL;
};
